
// Extending the SearchBar component to accept the initialValue prop
import React, { useState } from 'react';
import { Search } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';

export interface SearchBarProps {
  onSearch: (query: string) => void;
  placeholder?: string;
  className?: string;
  initialValue?: string;
}

const SearchBar = ({ onSearch, placeholder = 'Search...', className = '', initialValue = '' }: SearchBarProps) => {
  const [query, setQuery] = useState(initialValue);
  
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (query.trim()) {
      onSearch(query);
    }
  };
  
  return (
    <form onSubmit={handleSubmit} className={className}>
      <div className="relative rounded-lg flex items-center w-full">
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-muted-foreground" />
        <Input
          type="search"
          className="pl-10 pr-24 py-6 border border-input text-lg rounded-lg w-full focus-visible:ring-video-blue/30"
          placeholder={placeholder}
          value={query}
          onChange={(e) => setQuery(e.target.value)}
        />
        <Button 
          type="submit" 
          className="absolute right-1 top-1/2 transform -translate-y-1/2 bg-video-blue hover:bg-video-blue/90"
        >
          Search
        </Button>
      </div>
    </form>
  );
};

export default SearchBar;
